import writtenNumber from 'written-number';

export const formatNumber = (e) => {
	const rounded = Math.round(e * 100) / 100,
		hasComma = rounded % 1 != 0;
	return {
		hasComma,
		beforeComma: hasComma ? writtenNumber(rounded.toString().split(".")[0], {lang: 'fr'}) : writtenNumber(rounded, {lang: 'fr'}),
		afterComma: hasComma ? writtenNumber(Number(rounded.toString().split(".")[1].slice(0, 2)).toString().length === 2 ? rounded.toString().split(".")[1].slice(0, 2) : Number(rounded.toString().split(".")[1].slice(0, 2) + "0"), {lang: 'fr'}) : 0 
	}
};

export const betterTypeName = e => {
	if(e?.toLowerCase().includes("app"))
		return "Appt."
	else if(e?.toLowerCase().includes("mag"))
		return "Mag."
	return e
}

export const capitalizeText = e => e?.toLowerCase().split(' ').map(t => t.charAt(0).toUpperCase() + t.slice(1)).join(' ')

// export default formatNumber;